import React from "react";

export default function GovernanceBlock({
  block,
  responses,
  updateText,
  isReadOnly
}) {
  return (
    <div className="governance-block table-card">

      <div className="section_b_title">
        {block.block_title}
      </div>
{isReadOnly && (

  <div className="alert alert-success mb-3">
    Governance disclosures are in read-only mode.
  </div>

)}
      {(block.questions || []).map((question) => (
        <div
          key={question.question_code}
          className="mb-4"
        >
          <label className="section_b_label" >
            {question.question_code} - {question.question_text}
          </label>
          
          {question.config_json?.table_type ==="yes_no_with_details" ? (

  <>
    <div
      style={{
        display: "flex",
        gap: "20px",
        marginBottom: "10px"
      }}
    >
    <div className="brsr-radio-group">
      <label className="brsr-radio-option">
  <input
    type="radio"
    name={question.question_code}
    disabled={isReadOnly}
    checked={
      responses?.text?.[
        question.question_code
      ]?.answer === "Yes"
    }
    onChange={() =>
      updateText(
        question.question_code,
        {
          ...(responses?.text?.[
            question.question_code
          ] || {}),
          answer: "Yes"
        }
      )
    }
  />
  {" "}Yes
</label>

      <label className="brsr-radio-option">
  <input
    type="radio"
    name={question.question_code}
    disabled={isReadOnly}
    checked={
      responses?.text?.[
        question.question_code
      ]?.answer === "No"
    }
    onChange={() =>
      updateText(
        question.question_code,
        {
          answer: "No",
          details: ""
        }
      )
    }
  />
  {" "}No
</label>
      </div>
    </div>

    {
      responses?.text?.[question.question_code]?.answer === "Yes" && (

      <textarea
        className="form-control"
        rows={5}
        disabled={isReadOnly}
        placeholder="Provide details"
        value={
          responses?.text?.[question.question_code]?.details || ""
        }
        onChange={(e) =>
  updateText(
    question.question_code,
    {
      ...(responses?.text?.[
        question.question_code
      ] || {}),
      details: e.target.value
    }
  )
        }
      />

    )}
  </>

) : (

  <textarea
    className="form-control"
    rows={5}
    disabled={isReadOnly}
    value={
      responses?.text?.[
        question.question_code
      ] || ""
    }
    onChange={(e) =>
      updateText(
        question.question_code,
        e.target.value
      )
    }
  />

)}
        </div>
      ))}

    </div>
  );
}